<template>
  <default>
    <div class="tw-w-full">
      <bread-crumb :breadcrumbs="breadcrumbs" />
      <v-card flat class="tw-mt-5 md:tw-mt-16">
        <div class="tw-px-4 md:tw-px-8">
          <card-title icon="mdi-account">Claims</card-title>
          <p class="tw-px-2 md:tw-px-6">Kindly select your cover type from the ones listed below</p>
          <v-radio-group class="my-2 tw-px-0 md:tw-px-6" v-model="form.covertype" :rules="[v => !!v || 'Selection choice is required']" row>
                <v-radio label="Motor" :value="1" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
                <v-radio label="Domestic Package" :value="2" @change="goToPolicies" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
                <v-radio label="Medical" :value="3" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
        </v-radio-group>
        </div>
        <div v-if="form.covertype === 1" >
          <div class="tw-px-4 md:tw-px-8">
          <card-title icon="mdi-account">Claim Form</card-title>
          <p class="tw-px-2 md:tw-px-6">Download the appropriate claim from the ones listed below</p>
        </div>
        <div class="tw-px-4 md:tw-px-12 tw-mt-4 tw-py-3 md:tw-py-4">
          <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4 md:tw-gap-8">
            <div v-for="(f, i) in forms" :key="i">
              <p class="tw-text-xl c-navy-text">{{ f.title }}</p>
              <v-btn color="primary" :href="f.link" link :download="f.title" target="_blank">Download</v-btn>
            </div>
          </div>
        </div>
        </div>
      </v-card>
      <v-card v-if="form.covertype === 1" flat class="tw-mt-5 md:tw-mt-16">
        <div class="tw-px-4 md:tw-px-8">
          <card-title icon="mdi-account">Claim Details</card-title>
          <p class="tw-px-2 md:tw-px-6">After filling the claim form, upload it plus the police abstract as well as your driving licence</p>
        </div>
        <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
          <v-form v-model="isValid">
            <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 md:tw-gap-8">
              <express-upload :uid="authenticatedUser['custom:kra-pin']" :phoneNumber="authenticatedUser.phone_number" :fullName="authenticatedUser.name" :email="authenticatedUser.email" name="Claim form" :bucket="bucket" />
              <express-upload :uid="authenticatedUser['custom:kra-pin']" :phoneNumber="authenticatedUser.phone_number" :fullName="authenticatedUser.name" :email="authenticatedUser.email" name="Police abstract" :bucket="bucket" />
              <express-upload :uid="authenticatedUser['custom:kra-pin']" :phoneNumber="authenticatedUser.phone_number" :fullName="authenticatedUser.name" :email="authenticatedUser.email" name="Driving licence" :bucket="bucket" />
            </div>

            <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
              <v-btn block large
                     color="secondary"
                     class="my-3 "
                     @click="proceed"
                     :disabled="!isValid"
              >
                {{ isValid ? 'Complete' : 'Check if all fields are filled' }}
              </v-btn>
            </v-card-actions>

          </v-form>
        </div>
      </v-card>
      <div v-if="form.covertype === 2">
      </div>
      <div v-if="form.covertype === 3">
        <v-card flat class="tw-mt-5 md:tw-mt-16">
        <div class="tw-px-4 md:tw-px-8">
          <card-title icon="mdi-account">Claim Details</card-title>
          <p class="tw-px-2 md:tw-px-6">Fill in the reimbursement claim form and upload it</p>
          <div v-for="(f, i) in medicalForms" :key="i">
              <p class="tw-text-xl c-navy-text">{{ f.title }}</p>
              <v-btn color="primary" :href="f.link" link :download="f.title" target="_blank">Download</v-btn>
            </div>
        </div>
        <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
          <v-form v-model="isValid">
            <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 md:tw-gap-8">
              <express-upload :uid="authenticatedUser['custom:kra-pin']" :phoneNumber="authenticatedUser.phone_number" :fullName="authenticatedUser.name" :email="authenticatedUser.email" name="Reimbursement Claim form" :bucket="bucketMedical" />
            </div>
            <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
              <v-btn block large
                     color="secondary"
                     class="my-3 "
                     @click="proceed"
                     :disabled="!isValid"
              >
                {{ isValid ? 'Complete' : 'Check if all fields are filled' }}
              </v-btn>
            </v-card-actions>

          </v-form>
        </div>
      </v-card>
      </div>
    </div>
  </default>
</template>

<script>
/* eslint-disable sonarjs/no-duplicate-string */
import CardTitle from '@/components/shared/CardTitle';
import { mapGetters } from 'vuex';
import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import ExpressUpload from '@/components/shared/ExpressUpload';

export default {
  name: 'ClaimDetails',
  components: {
    ExpressUpload,
    BreadCrumb,
    Default,
    CardTitle,
  },
  data() {
    return {
      isValid: false,
      breadcrumbs: [
        {
          text: 'Make A Claim',
          disabled: true,
          to: { name: 'Claims' },
        },
      ],
      bucket: 'gi-claims',
      bucketMedical: 'medical',
      forms: [
        {
          title: 'Motor Accident Claim Form',
          link: '/docs/motor_accident_claim_form.doc',
        },
        {
          title: 'Motor Theft Report Form',
          link: '/docs/motor_theft_report_form.doc',
        },
        {
          title: 'Motor Windscreen Claim Form',
          link: '/docs/motor_windscreen_claim_form.doc',
        },
      ],
      medicalForms: [
        {
          title: 'Medical Reimbursement Claim Form',
          link: '/docs/reimbursement_medical_claim_form.pdf',
        },
      ],
      form: {
        covertype: 'motor',
      },
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser']),
  },
  methods: {
    proceed() {
      this.$router.push({ name: 'Dashboard' });
    },
    goToPolicies() {
      this.$router.push({ name: 'MyPolicies' });
    },
  },
};
</script>
